import React from 'react';
import { trackEvent } from '../config/site';
import { Sparkles, Users, MessageSquare, Terminal, ArrowRight } from 'lucide-react';

interface PrivateBetaSectionProps {
  onOpenWaitlist: () => void;
}

export const PrivateBetaSection: React.FC<PrivateBetaSectionProps> = ({ onOpenWaitlist }) => {
  const handleCta = () => {
    trackEvent('final_cta', { location: 'private_beta_section' });
    onOpenWaitlist();
  };

  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      {/* Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-brand-primary/10 rounded-full blur-[140px] pointer-events-none -z-10" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="p-8 sm:p-14 rounded-3xl bg-gradient-to-b from-brand-surface via-brand-surface to-brand-bg border border-brand-primary/30 text-center shadow-2xl relative">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-brand-primary/15 text-brand-cyan text-xs font-semibold border border-brand-primary/30 mb-6">
            <Sparkles className="w-3.5 h-3.5" />
            <span>Acesso Antecipado e Colaborativo</span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-6">
            Construa o Futuro da Engenharia de Infoprodutos Conosco
          </h2>

          <p className="text-base sm:text-lg text-brand-textMuted max-w-2xl mx-auto mb-10 leading-relaxed">
            Estamos liberando acessos gradualmente em lotes supervisionados para criadores, educadores técnicos e coprodutores dispostos a fornecer feedback técnico em tempo real.
          </p>

          {/* Pillars of Private Beta */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-left mb-10">
            <div className="p-5 rounded-2xl bg-brand-bg/80 border border-brand-border/60">
              <Users className="w-6 h-6 text-brand-cyan mb-3" />
              <h4 className="text-sm font-bold text-white mb-1">Lotes Controlados</h4>
              <p className="text-xs text-brand-textMuted">Garantia de recursos computacionais e atenção individualizada para cada projeto.</p>
            </div>

            <div className="p-5 rounded-2xl bg-brand-bg/80 border border-brand-border/60">
              <MessageSquare className="w-6 h-6 text-brand-primary mb-3" />
              <h4 className="text-sm font-bold text-white mb-1">Canal Direto de Feedback</h4>
              <p className="text-xs text-brand-textMuted">Contato próximo com os arquitetos e engenheiros de produto do InfoForge.</p>
            </div>

            <div className="p-5 rounded-2xl bg-brand-bg/80 border border-brand-border/60">
              <Terminal className="w-6 h-6 text-emerald-400 mb-3" />
              <h4 className="text-sm font-bold text-white mb-1">Evolução Semanal</h4>
              <p className="text-xs text-brand-textMuted">Melhorias contínuas nos compiladores, modelos e refinamentos de diagramação.</p>
            </div>
          </div>

          {/* CTA */}
          <button
            onClick={handleCta}
            className="px-8 py-4 rounded-xl text-base font-semibold text-white bg-gradient-to-r from-brand-primary via-brand-secondary to-brand-primary bg-[length:200%_auto] hover:bg-right transition-all duration-500 shadow-xl shadow-brand-primary/25 hover:shadow-brand-primary/40 inline-flex items-center gap-3 hover:scale-[1.02] active:scale-[0.98]"
          >
            Quero Participar do Private Beta
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};
